import { z } from 'zod';
/*
  Base Map Hidden Layers
*/
export const BasemapTweakSchema = z.enum([
    'Hide Green',
    'Hide Labels',
    'Hide Built Environment',
    'Disable Terrain Exaggeration'
]);
// These are icons that could not be replaced automatically in Mapbox Studio
// All light base map icons were able to be replaced in studio, but not the satellite icons
// If a light base map icon does need to be replaced, simply add the key "light" to the iconConfig object with the path to the new icon
export const iconConfig = {
    bus: {
        satellite: '/images/mapboxIconsPOI/satellite/bus.png',
        layer: 'transit-label'
    },
    airport: {
        satellite: '/images/mapboxIconsPOI/satellite/airport.png',
        layer: 'airport-label'
    },
    'bicycle-share': {
        satellite: '/images/mapboxIconsPOI/satellite/bicycle-share.png',
        layer: 'transit-label'
    },
    rail: {
        satellite: '/images/mapboxIconsPOI/satellite/rail.png',
        layer: 'transit-label'
    }
};
//# sourceMappingURL=baseMap.js.map